import { IAuthProvider, IUser, UserRole } from './IAuthProvider';

export class JwtAuthProvider implements IAuthProvider {
  readonly supportsLogin = true;
  private cached: IUser | null | undefined = undefined;

  constructor(private baseUrl: string = '/api') {}

  async getCurrentUser(): Promise<IUser | null> {
    if (this.cached !== undefined) return this.cached;
    try {
      const res = await fetch(`${this.baseUrl}/auth/me`, { credentials: 'include' });
      if (res.status === 401) { this.cached = null; return null; }
      if (!res.ok) throw new Error(`auth/me ${res.status}`);
      const user = (await res.json()) as IUser;
      this.cached = user;
      return user;
    } catch {
      this.cached = null;
      return null;
    }
  }

  async hasRole(role: UserRole): Promise<boolean> {
    const u = await this.getCurrentUser();
    if (!u) return false;
    if (role === 'admin') return u.role === 'admin';
    if (role === 'client') return u.role === 'admin' || u.role === 'client';
    return true;
  }

  async login(email: string, password: string): Promise<IUser> {
    const res = await fetch(`${this.baseUrl}/auth/login`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(text || 'Échec de la connexion');
    }
    const user = (await res.json()) as IUser;
    this.cached = user;
    return user;
  }

  async logout(): Promise<void> {
    await fetch(`${this.baseUrl}/auth/logout`, { method: 'POST', credentials: 'include' });
    this.cached = null;
  }
}
